




































































































    import { Vue, Component, Watch } from 'vue-property-decorator';
    import { StoreState } from '../../../store';
    import { mapState, mapGetters } from 'vuex';
    import DayOfWeek from './DayOfWeek.vue';
    import TimeSelector from './TimeSelector.vue';
    import VueElementLoading from 'vue-element-loading'; 
    import SchedulePicker from '../schedule-container/SchedulePicker.vue';
    import CallDirectionFilter from '../filter-container/CallDirectionFilter.vue';
    import CallDirectionFilterSchedul from '../filter-container/CallDirectionFilter_Schedul.vue';
    import AnsweredFilter from '../filter-container/AnsweredFilter.vue';
    import AnsweredFilterSchedul from '../filter-container/AnsweredFilter_Schedul.vue';

    import ExtensionsFilterSchedul from '../filter-container/ExtensionsFilter_schedul.vue';
    import TimeZoneFilter from '../filter-container/TimezoneFilter.vue';
 

    @Component({
        components: {
            DayOfWeek,
            TimeSelector,SchedulePicker,CallDirectionFilterSchedul,AnsweredFilterSchedul,ExtensionsFilterSchedul, 
             TimeZoneFilter ,VueElementLoading
        },
          watch: {
            dailyTime(newVal, oldVal) {
               
                (this.$refs.dailyTime as any).setTime(newVal);
            },
            weeklyTime(newVal, oldVal) { 
              
                (this.$refs.weeklyTime as any).setTime(newVal);
            },
            monthlyTime(newVal, oldVal) {
               
                (this.$refs.monthlyTime as any).setTime(newVal);  
            },  
          },  
        computed: {
            ...mapState({
                'dayEnabled': (state: StoreState) => state.reports.scheduleForm.enabledDay,
                'dailyEnabled': (state: StoreState) => state.reports.scheduleForm.dailyEnabled,
                'weeklyEnabled': (state: StoreState) => state.reports.scheduleForm.weeklyEnabled,
                'monthlyEnabled': (state: StoreState) => state.reports.scheduleForm.monthlyEnabled,
                'monthlyDelivery': (state: StoreState) => state.reports.scheduleForm.monthlyDelivery,
                'email': (state: StoreState) => state.reports.scheduleForm.email,
                'filename': (state: StoreState) => state.reports.scheduleForm.filename,
                'weeklyTime': (state: StoreState) => state.reports.scheduleForm.weeklyTime,
                'dailyTime': (state: StoreState) => state.reports.scheduleForm.dailyTime,
                'monthlyTime': (state: StoreState) => state.reports.scheduleForm.monthlyTime,
                'inboundcall':(state: StoreState) => state.reports.filters.inboundChecked_schedule,
                'outboundcall':(state: StoreState) => state.reports.filters.outboundChecked_Schedule,
                'answeredYes': (state: StoreState) => state.reports.filters.answeredYes_schedule,
                'answeredNo': (state: StoreState) => state.reports.filters.answeredNo_schedule,
                'startDate': (state: StoreState) => state.reports.filters.startDate_Schedul,
                'endDate': (state: StoreState) => state.reports.filters.endDate_Schedul,
                'WeeklyDays_EnalbeList': (state: StoreState) =>  state.reports.scheduleForm.WeeklyDays_EnalbeList,
            }),
            ...mapGetters([
                'scheduleButtonDisabled'
            ])
        }
    })
    export default class ScheduleForm extends Vue {
       
        filename!:         string;
        email!:            string;
        dailyEnabled!:     boolean;
        weeklyEnabled!:    boolean;
        monthlyEnabled!:   boolean;
        dayEnabled:       string;
        monthlyDelivery!:  string;
        weeklyTime!:       Date;
        dailyTime!:        Date;
        monthlyTime!:      Date;
        statusMessage:    string = '';
        invalidCondition: string = '';
        loading = false;
        inboundcall:boolean;
        outboundcall:boolean;
        answeredYes:boolean;
        answeredNo:boolean;
        startDate!: Date | null;
        endDate!: Date | null;
        
     blockSpecialChar(event){
	    var k= event.keyCode;
        if(!((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32  || (k >= 48 && k <= 57)))
            return event.preventDefault();    
     }
     
        validateForm() {
            const isTimeValid = [
                [this.dailyEnabled, this.dailyTime],
                [this.weeklyEnabled, this.weeklyTime],
                [this.monthlyEnabled, this.monthlyTime]
            ].filter(r => this.isTimeValid(<any>r) === true);

            this.statusMessage = '';
            this.invalidCondition='';
     
      
            if (!this.dailyEnabled && !this.weeklyEnabled && !this.monthlyEnabled) 
            {
                this.statusMessage = '<p>Please select a report frequency.</p>';
                this.invalidCondition = 'noFrequencySelected';
            } 
             if (isTimeValid.length === 0) 
            {
                this.statusMessage = '<p>Please select a time.</p>';
                this.invalidCondition = 'noTimeSelected';
            }
              var WeeklyDays=false;
              (this as any).WeeklyDays_EnalbeList.forEach(function(e1)  {  if(e1.value){  WeeklyDays=true; }   }); 
               //chec once for weekly days
            //  if (this.weeklyEnabled && (this.dayEnabled===""|| this.dayEnabled==="none")) 
            if (this.weeklyEnabled && (!WeeklyDays)) 
            {
                this.statusMessage += `<p>Please choose a day of the week.</p>`;
                this.invalidCondition += ' noDaySelected';
            }

            if (this.monthlyEnabled && this.monthlyDelivery === 'none') {
                this.statusMessage += `<p>Please choose a valid delivery date.</p>`;
                this.invalidCondition += ' noDoMSelected';
            }

            if (this.email.indexOf('@') < 0) {
                this.statusMessage += `<p>Please enter a valid email address.</p>`;
                this.invalidCondition += ` noEmailEntered`;
            }

            if (this.filename.length === 0) {
                this.statusMessage += `<p>Please enter a valid file name.</p>`;
                this.invalidCondition += ` noFileNameEntered`;
            }

            if (!this.inboundcall && !this.outboundcall) {
                this.statusMessage += `<p>Please enter a calldirection.</p>`;
                this.invalidCondition += ` nocalldirection`;
            }
            if (!this.answeredYes && !this.answeredNo) {
                this.statusMessage += `<p>Please enter a Answered.</p>`;
                this.invalidCondition += ` noAnsweredstatus`;
            }

            if (this.invalidCondition === '') {
                this.loading = true;
                this.$store.dispatch('saveReportAsScheduled').then(r => {
                          this.loading = false;
                    }).catch(() => {
                    });
            }
        } 
      
        get inboundChecked() {
            return this.$store.state.reports.filters.inboundChecked_schedule;
        }

        get outboundChecked() {
            return this.$store.state.reports.filters.outboundChecked_Schedule;
        }

        changeFrequency(frequency: 'daily' | 'weekly' | 'monthly', $event: any) {
            (this.$refs.dailyTime as any).setTime(null    );
                (this.$refs.weeklyTime as any).setTime(null    );
                 (this.$refs.monthlyTime as any).setTime(null    );
            this.resetErrorState();
            this.$store.dispatch('setScheduleFrequency', {
                daily: frequency === 'daily' && $event.target.checked,
                monthly: frequency === 'monthly' && $event.target.checked,
                weekly: frequency === 'weekly' && $event.target.checked
            });
            var newTime=-1;
            this.$store.commit('SET_DAILY_TIME',   {newTime  });
            this.$store.commit('SET_MONTHLY_TIME', {newTime  });
            this.$store.commit('SET_WEEKLY_TIME', {newTime  });
           // this.$store.commit('SET_SCHEDULE_WEEKLY_DAYS',  []);



        }

        updateMonthlyDeliveryStream(frequency: 'first' | 'fifteenth' | 'last') {
            this.resetErrorState();
            this.$store.dispatch('setMonthlyFrequency', { frequency });
        }

        timeChange(newTime: Date, frequency: 'daily' | 'weekly' | 'monthly') {
            let mutationName = 'SET_DAILY_TIME';
            switch(frequency) {
                case('weekly'):
                    mutationName = 'SET_WEEKLY_TIME';
                    break;  
                case('monthly'):
                    mutationName = 'SET_MONTHLY_TIME';  
                    break;
                case('daily'):
                default:
                    break;
            }
            this.$store.commit(mutationName, {
                newTime  
            });
        }
       
        resetErrorState() {
            this.statusMessage = '';
            this.invalidCondition = '';

        }

        isTimeValid([isEnabled, timeValue]: any): boolean {
            if (isEnabled) {
                return timeValue !== -1;
            }
            return false;
        }

        deleteReport(e: any) {
            this.$emit('deleteReport', e);
        }



        inboundCallCheckedChanged(newVal: any) {
            this.resetErrorState();
            this.$store.commit('INBOUND_CALL_CHANGE_SCHEDULE', {
                newVal
            });
        }

        outboundCallCheckedChanged(newVal: any) {
            this.resetErrorState();
            this.$store.commit('OUTBOUND_CALL_CHANGE_SCHEDULE', {
                newVal
            });
        }

        answeredYesCheckChanged(newVal: any) {
            this.resetErrorState();
            this.$store.commit('ANSWERED_YES_CHANGE_SCHEDULE', {
                newVal
            });
        }

        answeredNoCheckChanged(newVal: any) {
            this.resetErrorState();
            this.$store.commit('ANSWERED_NO_CHANGE_SCHEDULE', {
                newVal
            });
        }


    }
